var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "no-gutters": ""
    }
  }, [!_vm.mobile ? _c('v-col', {
    staticClass: "employment-form-form__side",
    attrs: {
      "cols": "12",
      "xl": ""
    }
  }, [_c('form-side', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1) : _vm._e(), !_vm.mobile ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1) : _vm._e(), _c('v-col', {
    key: _vm.key,
    staticClass: "employment-form-form__body",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "cols": "12",
      "xl": ""
    }
  }, [_c('form-body', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _vm.mobile ? _c('form-tool', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e(), _vm.mobile ? _c('form-edit') : _vm._e(), _vm.mobile ? _c('form-list', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e()], 1), !_vm.mobile ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1) : _vm._e(), !_vm.mobile ? _c('v-col', {
    staticClass: "employment-form-form__desc",
    attrs: {
      "cols": "12",
      "xl": ""
    }
  }, [_c('form-desc', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1) : _vm._e(), _c('form-init', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }